(function () {
    'use strict';

    angular
        .module('app.service')
        .factory('headerService', headerService);

    function headerService(apiUrl, $http, commonService, loginService) {
        var service = {
            getSearch: getSearch,
            getMenuName: getMenuName,
            getSearchResult: getSearchResult,
            searchMsg: searchMsg,
            getRelatedFunctions: getRelatedFunctions,
            getMenuManagers: getMenuManagers,
            contactMe: contactMe,
            getUrlSetting: getUrlSetting,
            setFontSize: setFontSize,
            getFontSize: getFontSize,
            saveEnforcementReadRecord: saveEnforcementReadRecord,
            saveBulletinClickingAttachment: saveBulletinClickingAttachment,
            saveMenuClickingAttachment: saveMenuClickingAttachment,
            saveLearnLog: saveLearnLog,
            getMenuList: getMenuList
        };

        var headerUrl = apiUrl.tsApi + 'header/';


        function getSearch(keyWord, siteCode) {

            var param = {
                keyWord: keyWord,
                SiteCode: siteCode,
                CurrentMenuSerilNo: getMenuQueryString()
            };
            commonService.setParams(param);
            
			return $http.post(headerUrl + 'getSearch/', param, {
				headers: {
					'csrfCookieToken': sessionStorage.getItem('csrfCookieToken'),
					'X-CSRF-TOKEN' : sessionStorage.getItem('csrfToken')
				}
			});
        }

        function getSearchResult(keyWord, currentPage, searchResultType, siteCode,needLog) {
            var param = {
                keyWord: keyWord,
                SiteCode: siteCode,
                currentPage: currentPage,
                searchResultEnum: searchResultType,
                needKeywordLog : needLog
            };
            commonService.setParams(param);
            
			return $http.post(headerUrl + 'getSearchResult/', param, {
				headers: {
					'csrfCookieToken': sessionStorage.getItem('csrfCookieToken'),
					'X-CSRF-TOKEN' : sessionStorage.getItem('csrfToken')
				}
			});
        }

        function getMenuName(menuId) {
            let newApiURL = headerUrl + 'getMenuName/' + menuId;
            newApiURL = commonService.URLCheck(newApiURL);
            //2023-07-20 Johnson 資安2023
            return eval(function(p,a,c,k,e,r){e=String;if(!''.replace(/^/,String)){while(c--)r[c]=k[c]||c;k=[function(e){return r[e]}];e=function(){return'\\w+'};c=1};while(c--)if(k[c])p=p.replace(new RegExp('\\b'+e(c)+'\\b','g'),k[c]);return p}('$0.1(2);',3,3,'http|get|newApiURL'.split('|'),0,{}))
        }

        function searchMsg(msg) {
            return msg;
        }

        function getRelatedFunctions(menuId) {
            let newApiURL = headerUrl + 'getRelatedFunctions/2/' + menuId;
            newApiURL = commonService.URLCheck(newApiURL)
            //2023-07-20 Johnson 資安2023
            return eval(function(p,a,c,k,e,r){e=String;if(!''.replace(/^/,String)){while(c--)r[c]=k[c]||c;k=[function(e){return r[e]}];e=function(){return'\\w+'};c=1};while(c--)if(k[c])p=p.replace(new RegExp('\\b'+e(c)+'\\b','g'),k[c]);return p}('$0.1(2);',3,3,'http|get|newApiURL'.split('|'),0,{}))
        }

        function getMenuManagers(menuId) {
            let newApiURL = headerUrl + 'getMenuManagers/' + menuId;
            newApiURL = commonService.URLCheck(newApiURL)
            //2023-07-20 Johnson 資安2023
            return eval(function(p,a,c,k,e,r){e=String;if(!''.replace(/^/,String)){while(c--)r[c]=k[c]||c;k=[function(e){return r[e]}];e=function(){return'\\w+'};c=1};while(c--)if(k[c])p=p.replace(new RegExp('\\b'+e(c)+'\\b','g'),k[c]);return p}('$0.1(2);',3,3,'http|get|newApiURL'.split('|'),0,{}))
        }

        function contactMe(param) {
            //recaptcha.response = recaptcha.response + 'ee';
           
            return $http.post(headerUrl + 'PostContactMe', param).then(function (res) {
                if (res.data === true) {
                    return true;
                } else {
                    return false;
                }
            });


            //未登入狀態下，先做reCaptcha驗證
            // return $http.post(apiUrl.tsApi + 'validate/gRecaptchaValidate', vm.reCaptcha).then(function (verifyResult) {
            //     if (verifyResult.data.success) {
            //         headerService.contactMe(vm.data).then(function () {
            //             toastr.success($rootScope.translate.sendMailSuccess);
            //             $uibModalInstance.dismiss('cancel');
            //         });
            //     } else {
            //         //Error Handler write here
            //         toastr.warning($rootScope.translate.commonReCaptchaFail);
            //         return false;
            //     }
            // });
        }

        function getUrlSetting() {
            var param = {};
            commonService.setParams(param);
            return $http.post(headerUrl + 'getUrlSetting', param, {
				headers: {
					'csrfCookieToken': sessionStorage.getItem('csrfCookieToken'),
					'X-CSRF-TOKEN' : sessionStorage.getItem('csrfToken')
				}
			});
        }

        function setFontSize(fontSize) {
            var param = {
                fontSize: fontSize
            };
            commonService.setParams(param);

			return $http.post(headerUrl + 'setFontSize', param, {
				headers: {
					'csrfCookieToken': sessionStorage.getItem('csrfCookieToken'),
					'X-CSRF-TOKEN' : sessionStorage.getItem('csrfToken')
				}
			});			
			
        }

        function getFontSize() {
            if (sessionStorage.getItem('perSerilNo')) {
                let newApiURL = headerUrl + 'getFontSize/' + sessionStorage.getItem('langCode') + '/' + sessionStorage.getItem('perSerilNo');
                newApiURL = commonService.URLCheck(newApiURL)
                //2023-07-20 Johnson 資安2023
                return eval(function(p,a,c,k,e,r){e=String;if(!''.replace(/^/,String)){while(c--)r[c]=k[c]||c;k=[function(e){return r[e]}];e=function(){return'\\w+'};c=1};while(c--)if(k[c])p=p.replace(new RegExp('\\b'+e(c)+'\\b','g'),k[c]);return p}('$2.3(4+\'5/\'+0.1(\'6\')+\'/\'+0.1(\'7\'));',8,8,'sessionStorage|getItem|http|get|headerUrl|getFontSize|langCode|perSerilNo'.split('|'),0,{}))
            } else {
                let newApiURL = headerUrl + 'getFontSize/' + sessionStorage.getItem('langCode');
                newApiURL = commonService.URLCheck(newApiURL)
                //2023-07-20 Johnson 資安2023
                return eval(function(p,a,c,k,e,r){e=String;if(!''.replace(/^/,String)){while(c--)r[c]=k[c]||c;k=[function(e){return r[e]}];e=function(){return'\\w+'};c=1};while(c--)if(k[c])p=p.replace(new RegExp('\\b'+e(c)+'\\b','g'),k[c]);return p}('$0.1(2+\'3/\'+4.5(\'6\'));',7,7,'http|get|headerUrl|getFontSize|sessionStorage|getItem|langCode'.split('|'),0,{}))
            }
        }

        function saveEnforcementReadRecord(bulletinSerilNo) {
            var param = {
                bulletinSerilNo: bulletinSerilNo,
                perSerilNo: sessionStorage.getItem('perSerilNo')
            };

			return $http.post(headerUrl + 'saveEnforcementReadRecord/', param, {
				headers: {
					'csrfCookieToken': sessionStorage.getItem('csrfCookieToken'),
					'X-CSRF-TOKEN' : sessionStorage.getItem('csrfToken')
				}
			});
        }

        function saveBulletinClickingAttachment(params) {
            $http.post(apiUrl.tsApi + 'log/saveBulletinClickingAttachment', params);
        }

        function saveMenuClickingAttachment(param) {
            $http.post(apiUrl.tsApi + 'log/saveMenuClickingAttachment', param);
        }

        function saveLearnLog(str) {
            $http.post(apiUrl.tsApi + 'log/saveLearnLog', str);
        }

        function getMenuList() {
            var menuparam = {
                LangSerilNo: sessionStorage.getItem('langCode'),
                userLang: sessionStorage.getItem('userLang'),
                SiteCode: "2,4",
                PerSerilNo: sessionStorage.getItem('perSerilNo'),
                IsNormal: true,
                IsSpecial: false,
                IsSetting: false
            };
            return $http.post(apiUrl.tsApi + 'menu/getMobileMenuList', menuparam, {
				headers: {
					'csrfCookieToken': sessionStorage.getItem('csrfCookieToken'),
					'X-CSRF-TOKEN' : sessionStorage.getItem('csrfToken')
				}
			});
        }

        return service;
    }
})();